'use client'

import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';

import SlotNumber, { hotnessForMinBet } from '../SlotNumber';


/**
 * This is a React functional component that displays the minimum bet info for casinos.
 * @returns {JSX.Element}
 */
export default function CasinoMinBetInSearch({ minBet, minBetType }: { minBet: number | null, minBetType: string }) {
    return (
        <Stack direction={'row'} spacing={1} sx={{ width: 120 }}>
            <Typography variant='body1' sx={{ fontWeight: 'bold' }}>{minBetType}:</Typography>
            <Typography variant='body1' component="span" sx={{ display: 'inline', textAlign: 'center' }}>
                <SlotNumber
                    value={minBet}
                    format={(n) => `$ ${n}`}
                    emptyText=" - "
                    hotness={hotnessForMinBet(minBet)}
                />
            </Typography>
        </Stack>
    );
}
